<template>
  <div class="nx-login-form__content">
    <ds-text
      v-text="text.description1"
    />
    <ds-heading size="300">
      {{ text.description2 }}
    </ds-heading>
    <ds-text tag="ol">
      <li v-html="$t('message.login.secondFactor.configuration.step1')" />
      <li class="mt-2">
        <span v-html="$t('message.login.secondFactor.configuration.step2')" />
        <qr-code
          v-if="provisioningUri"
          :value="provisioningUri"
          class="text-xs-center my-4"
          size="200"
        />
      </li>
      <li v-text="$t('message.login.secondFactor.configuration.step3')" />
    </ds-text>


    <nx-form
      ref="form"
      @form="form = $event"
      @submit.prevent="submit"
    >
      <nx-form-text
        v-model="otp"
        :label="$t('message.form.fields.otp')"
        append-icon="password"
        autofocus
        mask="### ###"
        name="otp"
        validation="required|second_factor_otp"
      />
      <v-container
        fluid
        class="grid-list-md pa-0 overflow-hidden"
      >
        <v-layout>
          <v-flex v-if="!firstTimeConfiguration">
            <v-btn
              block
              color="nx-neutral-200"
              @click="$emit('close')"
            >
              {{ $t('message.common.cancel') }}
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn
              :disabled="form.invalid || form.pristine"
              :loading="loading"
              block
              color="secondary"
              type="submit"
            >
              {{ $t('message.login.secondFactor.verify') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </nx-form>
  </div>
</template>

<script>
/**
 * Este componente permite al usuario configurar su segundo factor de autenticación.
 * Esta lógica se ha extraído en un componente aislado para poder reutilizarla en el flujo de login y en el flujo de
 * restablecimiento del segundo factor de autenticación.
 * @see src/modules/authentication/components/AuthSecondFactorConfiguration.vue
 * @see src/modules/entity/actions/EntityResetSecondFactorAction.vue
 */

import { mapState } from 'vuex';
import QrCode from 'qrcode.vue';
import NxFormText from '@/modules/form/components/FormText.vue';
import NxForm from '@/modules/form/Form.vue';
import AuthComponent from '@/modules/authentication/mixins/auth-component';

export default {
  name: 'NxAuthSecondFactorConfigurationForm',
  components: {
    NxForm,
    NxFormText,
    QrCode,
  },
  mixins: [AuthComponent],
  props: {
    firstTimeConfiguration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      otp: '',
      form: {},
      provisioningUri: null,
    };
  },
  computed: {
    ...mapState('authentication', ['secondFactorJwt', 'otpProvisioningUri']),
    text() {
      const prefix = this.firstTimeConfiguration ? 'configuration' : 'reset';
      return {
        description1: this.$t(`message.login.secondFactor.${prefix}.description1`),
        description2: this.$t(`message.login.secondFactor.${prefix}.description2`),
      };
    },
  },
  watch: {
    otpProvisioningUri: {
      handler(newValue) {
        if (!newValue) return;
        this.provisioningUri = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    async submit() {
      if (this.loading) {
        return;
      }

      const result = this.firstTimeConfiguration
        ? await this.dispatch('authentication/SECOND_FACTOR_VERIFICATION', { otp: this.otp })
        : await this.dispatch('authentication/SECOND_FACTOR_RESET', { otp: this.otp });

      if (!result.success) {
        await this.$nextTick();
        this.$refs.form.errors.add({
          field: 'otp',
          msg: this.$t('message.error.invalidSecondFactorOtp'),
        });
      } else {
        this.$emit('input', true);
      }
    },
  },
};
</script>
